import { useEffect, useState } from 'react'
import vegkameraIconResource from "../../../assets/cctv.svg"
import { useRoadFeatureResponseMarkersActions, useRoadFeatureResponseMarkersState } from '../../../stores/MapLayers/RoadFeatureResponseMarkersStore';

export function RoadFeatureResponseMapLayer() {
    const [className, setClassName] = useState('mapLayerContainerInactive');

    const open = useRoadFeatureResponseMarkersState();
    const { toggleOpen } = useRoadFeatureResponseMarkersActions();

    useEffect(() => {
        if(open){
            setClassName('mapLayerContainerActive')
        }
        else{
            setClassName('mapLayerContainerInactive')
        }
    }, [open])


    return(
        <div style={{display: 'grid', marginLeft: '20px', maxHeight: '90%'}}>
            <div className={className} onClick={toggleOpen}>
                <img src={vegkameraIconResource} alt="RoadfeaturesAPI Response kartlag " style={{width: '28px', height: '6vh', margin: 'auto'}}/>
            </div>
            <p style={{fontSize: '14px', margin: 'auto', fontWeight: 'bold'}}>Response elementer</p>
        </div>
    )
}